module.exports = {
      id: "icon-calendar-check-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-calendar-check",
      toString: function () {
        return this.url;
      }
    }